import { CustomButton } from "./CustomButton"

export const FormClosed = () => {
    return (
        <div>
            <div className="flex flex-col lg:flex-row min-h-screen pt-navbar py-40 mx-[10%]">
                <div className={`lg:order-2 flex-auto w-full`} >
                    <div className={`w-[100%] p-[12%]`}>
                        <div className="flex justify-between items-center">
                            <h2>Sorry, this form is now closed.</h2>
                        </div>

                        <div className='py-4'>
                            <h4 className="text-grey-body xl:max-w-[50%]">
                                Feel free to contact us if you have any questions!
                            </h4>
                            <CustomButton
                                text={'Back to home'}
                                className={'mt-[1.72rem]'}
                                link={'/'}
                                newWindow={false}
                            />
                        </div>
                    </div></div>
            </div></div>
    )
}